import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  alternativeButtonStyle
} from '../styles/buttonStyles'

const FuelCashbackInfoModal = ({
  open,
  onClose
}) => {
  const { t } = useTranslation()

  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  const infoParagraphs = useMemo(
    () =>
      String(
        t(
          'TRIPLOG.RECEIPTS.TABLE.FUEL_CASHBACK_INFO_TEXT'
        )
      ).split(/\n\s*\n/),
    [t]
  )

  useEffect(() => {
    if (!open) return

    const handleKeyDown = e => {
      if (e.key !== 'Escape') return

      e.preventDefault()
      e.stopPropagation()

      onClose()
    }

    window.addEventListener(
      'keydown',
      handleKeyDown
    )

    return () => {
      window.removeEventListener(
        'keydown',
        handleKeyDown
      )
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor:
          'rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 5000
      }}
    >
      <div
        onClick={e =>
          e.stopPropagation()
        }
        style={{
          background: '#122629',
          padding: 20,
          border:
            '2px solid #107c6b',
          borderRadius: 12,
          boxShadow:
            '0 12px 28px rgba(0,0,0,0.65)',
          width:
            'clamp(320px, 32vw, 520px)',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            width: '100%',
            textAlign: 'left',
            marginBottom: 24,
            overflowY: 'auto'
          }}
        >
          <p
            style={{
              fontSize: 20,
              margin: '0 0 14px 0',
              color: '#d9ffe4',
              fontWeight: 700,
              textAlign: 'center'
            }}
          >
            {t(
              'TRIPLOG.RECEIPTS.TABLE.FUEL_CASHBACK_INFO_TITLE'
            )}
          </p>

          {infoParagraphs.map(
            (paragraph, index) => (
              <p
                key={index}
                style={{
                  fontSize: 15,
                  lineHeight: 1.5,
                  margin:
                    index ===
                    infoParagraphs.length - 1
                      ? 0
                      : '0 0 14px 0',
                  color:
                    'rgba(217,255,228,0.85)',
                  whiteSpace: 'pre-line'
                }}
              >
                {paragraph}
              </p>
            )
          )}
        </div>

        <button
          style={alternativeButtonStyle(
            pressedBtn,
            'closeFuelCashbackInfo',
            hoverBtn ===
              'closeFuelCashbackInfo'
          )}
          onMouseEnter={() =>
            setHoverBtn(
              'closeFuelCashbackInfo'
            )
          }
          onMouseLeave={() => {
            setHoverBtn(null)
            setPressedBtn(null)
          }}
          onMouseDown={() =>
            setPressedBtn(
              'closeFuelCashbackInfo'
            )
          }
          onMouseUp={() =>
            setPressedBtn(null)
          }
          onClick={onClose}
        >
          {t('CLOSE')}
        </button>
      </div>
    </div>
  )
}

export default FuelCashbackInfoModal